// extracted by mini-css-extract-plugin
module.exports = {"img":"img___2-vs0","btn":"btn___1bbGW"};